export default "__VITE_ASSET__DKkR6E7I__"